import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NeoComunService } from '../../../comun/services/neoComun.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { AlertService } from '../../../services/alert.service';
import { RouterService } from '../../../services/router.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;

const datosDetalleSolicitud = {
  idSolicitud: '',
  usuario: null,
};

const datosDevolverSolicitud = {
  idCliente: null,
  idUsuario: null,
  idSolicitud: '',
  idMotivoDevolucionIF: null,
  observacion: '',
};
@Component({
    selector: 'app-devolver-negacion-if',
    templateUrl: './devolver-negacion-if.component.html',
    styleUrls: ['./devolver-negacion-if.component.scss'],
    providers: [NeoComunService, NeoIntermediarioFinancieroService],
    standalone: false
})
export class DevolverNegacionIfComponent implements OnInit {
  public detalleSolcitud: any;
  public user;
  public motivosDevolucion: any[] = [];
  tipoDevolucionId: Number = 0;
  observacionDevolver: String = '';

  constructor(
    public router: Router,
    private _route: ActivatedRoute,
    private _neoComunService: NeoComunService,
    private _userIntermediarioService: UserService,
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private alertService: AlertService,
    private _router: RouterService,
    private _sweetAlert:SweetAlertService
  ) {
    this.user = this._userIntermediarioService.getUser();
  }

  ngOnInit(): void {
    this._route.params.subscribe((params: Params) => {
      datosDetalleSolicitud.idSolicitud = params['id'];
      datosDetalleSolicitud.usuario = Number(this.user.idUsuario);
    });

    this._neoComunService.getDetalleSolicitud(datosDetalleSolicitud).subscribe(
      (response) => {
        this.detalleSolcitud = response;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,
          'No fue posible cargar el detalle de la solicitud'
        );
        this.router.navigate(['intermediario/transaccional/aprobarSolicitudes']);
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );

    this._neoIntermediarioFinancieroService.getMotivosDevolucion().subscribe(
      (response) => {
        this.motivosDevolucion = response['data'];
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,
          'No fue posible cargar los motivos de devolución'
        );
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );
    datosDevolverSolicitud.idCliente = Number(this.user.idCliente);
    datosDevolverSolicitud.idSolicitud = datosDetalleSolicitud.idSolicitud;
    datosDevolverSolicitud.idUsuario = Number(this.user.idUsuario);
  }

  cancelar() {
    this._router.goBack();
  }

  devolver() {
    if (this.observacionDevolver != '') {
      datosDevolverSolicitud.observacion = this.observacionDevolver.toString();
      if (this.tipoDevolucionId != 0) {
        datosDevolverSolicitud.idMotivoDevolucionIF = Number(
          this.tipoDevolucionId
        );
        this._neoIntermediarioFinancieroService
          .devolverSolicitud(datosDevolverSolicitud)
          .subscribe(
            (response) => {
              if (response['exitoso'] == true) {
                this._sweetAlert.successModal('¡Éxito!',
                false,
                'La solicitud ha sido devuelta correctamente').then(
                  (result)=>{
                    if(result.isConfirmed){
                      this.router.navigate(['/intermediario/home']);
                    }
                  });
              } else {
                this._sweetAlert.errorModal("Error!",true,
                  'No fue posible devolver la negación de la solicitud'
                );
              }
            },
            (error) => {
              this._sweetAlert.errorModal("Error!",true,
                'No fue posible devolver la negación de la solicitud'
              );
            }
          );
      } else {
        this._sweetAlert.errorModal("Error!",true,'Seleccione el tipo de devolucion');
      }
    } else {
      this._sweetAlert.errorModal("Error!",true,'Ingrese la observacion');
    }
  }

  aceptar() {
    $('#aceptarModal').modal('hide');
    this.router.navigate(['/intermediario/home']);
  }
}
